<template lang='pug'>
  .boost-hero-banner.clearfix(@click="$root.scrollTo(selector)")
    .banner-wrap.xs-12.text-center.xs-f-small.max-at-tweak
      .boosts-image
        img-box(media-id="6315")
      p.bold.xs-f-medium.lg-f-large.max-at-tweak Meet the Pro Boosts
      p.try-text.bold.color-purple.xs-f-small.lg-f-medium.max-at-tweak Try for ${{boostPrice}}

</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: "BoostHeroBanner",

    props: {
      selector: {
        type: String
      }
    },

    computed: {
      ...mapState('xsell', ['boostRecommendations']),

      boostPrice() {
        if (this.boostRecommendations.length) {
          return this.boostRecommendations[0].price;
        }

        return null;
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .boost-hero-banner
    position relative
    background-color #fbfbfb
    
    .banner-wrap
      padding 1.5em 5%
    
    .boosts-image
      position absolute
      top -4em
      left 50%
      margin-left -20em
      width 9em
      height 9em
      border-radius 50%
      background-color color-white
      overflow hidden
      
    @media mq-mobile
      .banner-wrap
        padding 1em 3%
        padding-left 45%
        
      .boosts-image
        margin-left 0
        left 4%
        
    @media mq-desktop-md-plus
      .try-text
        position absolute
        top 50%
        margin-top -0.75em
        right 50%
        margin-right -12.5em
    
</style>
